export default {
  methods: {
    async getImg (img) {
      // console.log(img)
      img.loading = true
      let path = img.url
      let suffix = path[0] === '/' ? path.slice(1) : path
      try {
        let data = await this.$store.dispatch('downloadFile', {url: `/violationApi/${suffix}`})
        let reader = new FileReader()
        reader.onload = (e) => {
          this.$set(img, 'src', e.target.result)
          // console.log(img, e.target)
        }
        reader.readAsDataURL(data)

        // console.log('get Img success', src)
      }
      catch (e) {
        img.error = true
        img.errorMessage = e.message
      }
      img.loading = false
    }
  }
}
